import { render, staticRenderFns } from "./OriginTable.vue?vue&type=template&id=32b786ae&"
import script from "./OriginTable.vue?vue&type=script&lang=ts&"
export * from "./OriginTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports